import { radioGroupClassName } from "@/app/(protected)/asset-generation/components/ExploreOptions/constant";

export const PRODUCT_IMAGE_OPTION_ERROR = "Please select a product image to generate a background";
export const IMAGE_GENERATED_BACKGROUND = "Product image placed with a generated background";
export const FULLY_GENERATED_IMAGE = "Fully generated image";
export const PRODUCT_PLACEMENT_LABEL = "Type of image to generate:";
export const PRODUCT_PLACEMENT_OPTIONS = [
  { id: FULLY_GENERATED_IMAGE, label: FULLY_GENERATED_IMAGE, ariaLabel: FULLY_GENERATED_IMAGE },
  {
    id: IMAGE_GENERATED_BACKGROUND,
    label: IMAGE_GENERATED_BACKGROUND,
    ariaLabel: IMAGE_GENERATED_BACKGROUND,
  },
];
export const PRODUCT_PLACEMENT_CONSTANTS = {
  SELECT_BUTTON_NAME: "Select product image",
  CHANGE_BUTTON_NAME: "Change product image",
};

export const productPlacementField = [
  {
    name: "productImageOption",
    options: PRODUCT_PLACEMENT_OPTIONS,
    label: "Type of image to generate:",
    ariaLabel: PRODUCT_PLACEMENT_LABEL,
    type: "radio" as unknown as "radio",
    radioGroupClassName: radioGroupClassName,
    optionLabelClassName: "!normal-case",
    errorMessageClassName: "px-6 bg-white -mt-4 pb-6",
    messagePosition: "bottom" as const,
  },
];
